<template>
  <div>
    <div class="user_content">
      <img src="../../assets/img/trustlook-logo.png" alt="" class="logo" />
      <div class="sign">
        <span ref="lang">
          <span @click="languageStatus = !languageStatus" class="choose icon-lang"></span>
          <el-collapse-transition>
            <ul class="language_selection" v-show="languageStatus">
              <li @click="switchLang('zh')" :class="{ active: lang === 'zh' }">中文</li>
              <li @click="switchLang('en')" :class="{ active: lang === 'en' }">English</li>
            </ul>
          </el-collapse-transition>
        </span>
      </div>
      <div class="content">
        <h2 class="title">{{ $t('user.ResetPassword') }}</h2>
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          class="signup_ruleForm"
        >
          <el-form-item prop="pass">
            <el-input
              type="password"
              v-model="ruleForm.pass"
              autocomplete="off"
              :placeholder="$t('user.Password')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="checkPass">
            <el-input
              type="password"
              v-model="ruleForm.checkPass"
              autocomplete="off"
              :placeholder="$t('user.ConfirmPassword')"
              @keyup.enter.native="getEnterCode"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div class="btn_sign" @click="submitForm('ruleForm')">
              <i class="el-icon-loading" v-if="loading"></i>{{ $t('message.CONFIRM') }}
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { Message } from 'element-ui'
import { validateEmail } from '@/views/public/validator'
import VueRouter from 'vue-router'

const { isNavigationFailure, NavigationFailureType } = VueRouter

export default {
  name: 'ResetPass',
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('errMsg.passwordErr1')))
      } else if (value.length < 6 || value.length > 20) {
        callback(new Error(this.$t('errMsg.passwordErr2')))
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('errMsg.confirmPasswordErr1')))
      } else if (value !== this.ruleForm.pass) {
        callback(new Error(this.$t('errMsg.confirmPasswordErr2')))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      languageStatus: false,
      user: {},
      ruleForm: {
        pass: '',
        checkPass: ''
      },
      rules: {
        pass: [{ validator: validatePass, trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }]
      }
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  methods: {
    getEnterCode: function(e) {
      var keyCode = window.event ? e.keyCode : e.which
      if (keyCode == 13) {
        this.submitForm('ruleForm')
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          let data = {
            password: this.ruleForm.pass
          }
          let token = this.$route.query.token
          axios
            .post(`/api/user/reset-password/${token}`, data)
            .then(res => {
              this.loading = false
              Message({ type: 'success', message: 'success', showClose: true })
              this.$router.push('/login').catch(err => {
                // to hide the below error message
                if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
                  throw Error(err)
                }
              })
            })
            .catch(err => {
              this.loading = false
              Message({
                type: 'error',
                message: err.response.data.statusCode + ' ' + err.response.data.message,
                showClose: true
              })
            })
          this.$refs[formName].clearValidate()
        } else {
          Message({ type: 'error', message: this.$t('errMsg.err1'), showClose: true })
          return false
        }
      })
    },
    switchLang(lang) {
      if (lang === this.$store.state.lang) return
      this.$store.commit('switchLang', lang)
      this.languageStatus = false
      Message({ type: 'success', message: this.$t('message.switchSuccessfully'), showClose: true })
      location.reload()
    }
  },
  mounted() {
    let _this = this
    document.addEventListener('click', e => {
      if (!!_this.$refs.lang && !!_this.$refs.lang.contains(e.target)) return
      _this.languageStatus = false
    })
  }
}
</script>
<style lang="scss" src="./user.scss" scoped></style>
<style lang="scss" scoped>
.content {
  width: 540px;
  height: 441px;
  box-sizing: border-box;
  padding: 0 70px;
  background: $bg-user-color;
  @include box-shadow2;
  @include border-radius(10px);
  .title {
    color: $white;
    font-size: 24px;
    height: 29px;
    margin: 60px 0 48px;
    font-family: NexaBold;
    font-weight: bold;
    text-align: center;
  }
  .signup_ruleForm {
    width: 100%;
    ::v-deep .el-form-item {
      margin-bottom: 40px;
    }
    ::v-deep .el-form-item__label {
      color: rgba(255, 255, 255, 0.4);
      margin-left: 16px;
      font-size: 16px;
    }
    .btn_sign {
      margin-top: 20px;
    }
  }
}
@media screen and (max-width: 450px) {
  .content {
    width: 100%;
    padding: 0 40px;
    background: none;
    box-shadow: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/resetPass.vue